import React from "react";
import ExcalidrawViewer from "../../components/ExcalidrawViewer";

const AustraliaKeyLeaders: React.FC = () => (
  <ExcalidrawViewer
    filePath="/excalidraw/australia-israel-iran-key-leaders.excalidraw"
    title="Key Australian Leaders: Israel-Iran Conflict"
    subtitle="Who supports what? Political leaders and their positions on Israel, Iran, and the war (March 2026)"
  />
);

export default AustraliaKeyLeaders;
